import Image from 'next/image';
import { motion, type HTMLMotionProps } from 'framer-motion';

import { cn } from '#/lib/utils';

import image from './images/light-polygon.png';

export function LightPolygon({ className, ...props }: HTMLMotionProps<'div'>) {
  return (
    <motion.div {...props} className={cn(className)}>
      <Image
        {...image}
        alt="Light Polygon"
        className="w-full h-full object-cover"
      />
    </motion.div>
  );
}
